import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-4bc88261"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cm-align-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-arrow-down el-icon--right" }, null, -1))

import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { ExportType } from './export-dropdown.service'


export default /*#__PURE__*/_defineComponent({
  __name: 'export-dropdown',
  props: {
  /** 兼容旧用法：直接传已翻译文案（切换语言需父级用 computed 包裹） */
  text: {
    type: String,
    default: '',
  },
  /** 主按钮文案 i18n 键，优先于 text */
  buttonTextI18nKey: {
    type: String,
    default: 'distributionRecord.exportRecord',
  },
  csvI18nKey: {
    type: String,
    default: 'distributionRecord.exportCsv',
  },
  excelI18nKey: {
    type: String,
    default: 'distributionRecord.exportExcel',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  /** 页面订阅权益；为 false 时与 disabled 等效 */
  hasPermission: {
    type: Boolean,
    default: true,
  },
},
  emits: ["export"],
  setup(__props, { emit: __emit }) {

const props = __props

const isDisabled = computed(() => props.disabled || !props.hasPermission)

const emits = __emit

const { t, locale } = useI18n()

const displayText = computed(() => {
  locale.value
  return props.text || t(props.buttonTextI18nKey)
})

const csvLabel = computed(() => {
  locale.value
  return t(props.csvI18nKey)
})

const excelLabel = computed(() => {
  locale.value
  return t(props.excelI18nKey)
})

function handleExport(type: ExportType) {
  emits('export', type)
}

return (_ctx: any,_cache: any) => {
  const _component_CmSvgIcon = _resolveComponent("CmSvgIcon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createBlock(_component_el_dropdown, {
    class: "cm-ui-mr10 cm-ui-ml10",
    type: "primary",
    size: "small",
    offset: 10,
    trigger: "click",
    disabled: isDisabled.value
  }, {
    dropdown: _withCtx(() => [
      _createVNode(_component_el_dropdown_menu, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_dropdown_item, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (handleExport(_unref(ExportType).csv)))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(csvLabel.value), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_dropdown_item, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (handleExport(_unref(ExportType).excel)))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(excelLabel.value), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_button, {
        type: "primary",
        size: "small",
        plain: "",
        disabled: isDisabled.value
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_CmSvgIcon, {
              name: "assets/icons/export",
              class: "cm-ui-mr5",
              monochrome: "",
              size: 16,
              color: "var(--el-color-primary)"
            }),
            _createTextVNode(" " + _toDisplayString(displayText.value) + " ", 1),
            _hoisted_2
          ])
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    _: 1
  }, 8, ["disabled"]))
}
}

})